module.exports = __webpack_public_path__ + "static/media/esperado_annonser.21d021c6.pdf";